import React from 'react';
import { Container } from 'reactstrap';
import ScheduleReportsTable from './ScheduleReportsTable';
import SelectProgram from '@/containers/Manager/components/SelectProgram';

const ScheduleReportsIndex = () => {
  return (
    <div className="manager-report manager-report--standalone">
      <Container className="manager-home__shell manager-home__content">
        <section className="manager-report__hero">
          <div className="manager-report__hero-card">
            <div className="manager-report__hero-copy">
              <h1 className="manager-report__title">Scheduled Reports</h1>
              <p className="manager-report__description">
                Create and manage recurring report deliveries for the selected program without leaving the reporting workspace.
              </p>
            </div>
          </div>
        </section>

        <section className="manager-report__toolbar">
          <div className="manager-report__toolbar-grid manager-report__toolbar-grid--single">
            <div className="manager-report__control manager-report__control--program">
              <span className="manager-report__control-label">Program</span>
              <div className="manager-report__control-body">
                <SelectProgram showRefresh={false} label={null} variant="manager-report" />
              </div>
            </div>
          </div>
        </section>

        <div className="manager-report__content">
          <section className="manager-report-legacy">
            <ScheduleReportsTable />
          </section>
        </div>
      </Container>
    </div>
  );
}

export default ScheduleReportsIndex;
